import { render, staticRenderFns } from "./TheRightPanelRendersController.vue?vue&type=template&id=088c08be&"
import script from "./TheRightPanelRendersController.vue?vue&type=script&lang=ts&"
export * from "./TheRightPanelRendersController.vue?vue&type=script&lang=ts&"
import style0 from "./TheRightPanelRendersController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports